export default "/images/trash-2.svg?bba7f8a90befcbd8f9c03856bf0b3e29";